import React from 'react';

import { Event } from '../../interfaces';
import { getBlockName } from '../../utils';

interface Props {
  event: Event;
}

export function Geocode(props: Props) {
  const text = getBlockName(props.event);

  return <>{text}</>;
}
